import { Box, Button, Stack, Typography, theme } from '@dtx-company/design-system/src'
import { FC } from 'react'
import { LargeProductSuitCardData } from '../types'
import Image from 'next/image'

const LargeProductSuitCard: FC<{ data?: LargeProductSuitCardData }> = ({ data }) => {
  if (!data) return null

  const isCreateFlowcodeBtn = data.button_label?.toLowerCase() === 'create a flowcode'
  const isImageRightAligned = data.image_alignment === 'Right'

  return (
    <Box
      sx={{
        paddingX: theme => theme.spacing(6)
      }}
    >
      <Stack
        direction={{
          xs: isImageRightAligned ? 'column' : 'column-reverse',
          lg: 'row'
        }}
        sx={theme => ({
          maxWidth: {
            xs: theme.spacing(136),
            lg: theme.spacing(249.5)
          },
          mx: 'auto'
        })}
      >
        <Box
          sx={{
            order: isImageRightAligned ? 2 : 1
          }}
        >
          {data.image?.url && (
            <Image
              src={data.image?.url}
              alt={data.image?.alt ?? ''}
              width={560}
              height={386}
              style={{
                width: '100%',
                height: 'auto',
                objectFit: 'contain'
              }}
            />
          )}
        </Box>
        <Stack
          direction={'column'}
          justifyContent="center"
          sx={theme => ({
            order: isImageRightAligned ? 1 : 2,
            maxWidth: {
              xs: theme.spacing(121.5),
              lg: 'auto'
            },
            mx: 'auto',
            ml: {
              lg: isImageRightAligned ? 0 : 9
            },
            mr: {
              lg: isImageRightAligned ? 9 : 0
            }
          })}
        >
          <Stack
            sx={{
              marginY: theme.spacing(4),
              textAlign: { xs: 'center', lg: 'left' }
            }}
            direction="column"
            alignItems={{
              xs: 'center',
              lg: 'start'
            }}
            spacing={theme.spacing(4)}
          >
            <Typography
              variant={data.largeTitle ? 'headlineMedium' : 'headlineSmall'}
              textAlign="center"
            >
              {data.subheader}
            </Typography>
            <Typography variant="bodyMedium">{data.description}</Typography>
            {data.button_label && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  width: '100%'
                }}
              >
                <Button
                  href={isCreateFlowcodeBtn ? undefined : data.button_href?.url}
                  onClick={isCreateFlowcodeBtn ? () => window.scrollTo(0, 0) : undefined}
                  variant="contained"
                  fullWidth
                  aria-label={`${data.button_label} page`}
                >
                  {data.button_label}
                </Button>
              </Box>
            )}
          </Stack>
        </Stack>
      </Stack>
    </Box>
  )
}

export default LargeProductSuitCard
